import { Box, Stack } from '@mui/material';
import { ReactElement, memo } from 'react';

interface SelloutLeftColumnsRowProps {
  Value: ReactElement;
  Title?: ReactElement;
  height?: string;
}

const SelloutLeftColumnsRow = ({ Title, Value, height }: SelloutLeftColumnsRowProps) => (
  <Stack
    direction="row"
    sx={{
      alignItems: 'center',
      height: height ?? '46px',
      width: '100%',
    }}
  >
    <Box
      sx={{
        width: '140px',
      }}
    >
      {Title}
    </Box>

    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
      }}
    >
      {Value}
    </Box>
  </Stack>
);

export default memo(SelloutLeftColumnsRow);
